<template>

  <div class="movie-index">

    <div class="movie-bn">
      <img src="../../assets/img/bn1.jpg">
    </div>

    <div class="search-word">
      <button @click="toVodSearch" class="s"><span>搜索视频</span></button>
      <button @click="showNav = !showNav" class="n"><span v-if="!showNav">显示分类</span><span v-else class="up">隐藏分类</span></button>
    </div>


    <div class="movie-nav" v-if="showNav">
      <ul>
        <li v-for="(item, index) in homeShelves" :key="index"  @click="toCategory(item.typeId)"><span></span><h5>{{ item.typeName }}</h5></li>
      </ul>
    </div>

    <div class="movie-box" v-for="(item, i) in homeShelves" :key="i">
      <h3  @click="toCategory(item.typeId)"><span :class="'icon-h3-' + item.typeId">{{ item.typeName }}</span><i>更多 >></i></h3>
      <div class="movie-box-flex">

        <div class="item"  v-for="(vodsItem, ii) in item.vods" :key="ii" @click="toVodDetail(vodsItem)">
          <!-- <a class="img" :style="'background-image:url(' + vodsItem.vodPic + ')'"></a> -->
          <a class="img">
            <img v-lazy="vodsItem.vodPic" />
          </a>
          <h5>{{vodsItem.vodName}}</h5>
        </div>

      </div>
    </div>

    <div v-show="isLoading" class="loadingBox">加载中</div>

    <vodBottom></vodBottom>

  </div>


</template>

<script>
import vodBottom from '@/components/layer1/bottomVod'
import vodService from "../../services/vodService";
import userService from "../../services/userService";

export default {
  name: "vod",
  data() {
    return {
      componentName: '',
      selected: {
        category: '0',
        publish: 'all'
      },
      isLoading: false,
      userInfo: '',
      homeShelves: '',
      showNav: false,
    }
  },

  computed: {
    // getPublishActive() {
    //   return this.selected.publish
    // },
    // getVodHomeActive() {
    //   return this.selected.category
    // }
  },

  methods: {
    getVodHome() {
      this.isLoading = true;
      vodService.getVodHome()
        .then(res => {
          this.homeShelves = res.data.shelves;
          this.isLoading = false;
        })
    },
    toVodSearch() {
      this.$router.isBack = true;
      this.$router.push({path: '/search-vod'});
    },
    toCategory(id){
      this.$router.isBack = false;
      this.$router.push({
        path: '/vod/category',
        query: {
          cid: id
        }
      })
    },
    toVodDetail(vod){
      this.$router.isBack = false;
      this.$router.push({
        path: '/vod/detail',
        query: {
          vodId: vod.vodId,
        }
      })
    },
  },
  components: {
    vodBottom: vodBottom,
  },
  mounted() {
    this.userInfo = userService.getLocalUserInfo();
    if (this.userInfo == null) {
      //document.getElementById("categoryReportUrl").href = getReportUrl(null);
    } else {
      //document.getElementById("categoryReportUrl").href = getReportUrl(this.userInfo.account);
    }
    this.componentName = this.$route.name;
    console.log(this.componentName, this.$store.state.pageState[this.componentName]);
    if (this.$store.state.pageState[this.componentName] && this.$router.isBack) {
      Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
      setTimeout(() => {
        let scrollDiv = document.getElementById('scroll-div-category');
        console.log(this.$store.state.pageState[this.$route.name].top);
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
      }, 0);
    } else {
      this.getVodHome();
    }
    this.$router.isBack = true;
  },
}
</script>

<style scoped>

.movie-index{  padding: 10px 10px 60px 10px; background: #f5f5f5;}
.movie-nav ul { display: flex; flex-wrap: wrap;}
.movie-nav ul li{ width: 20%; text-align: center;  height: 3rem; line-height: 3rem; margin-bottom: 10px;}
.movie-nav ul li span{ font-size:.6rem;height:2rem; line-height: 2rem; width: 2rem; margin: 0 auto;
  display: block; border-radius: 50%; overflow: hidden; color: #fff; font-weight: 500;
  box-shadow: 0 0.1rem 0.1rem rgba(158, 101, 243, 0.15);
  background: url(../../assets/img/icon-h3-2.png) center center no-repeat;
  background-size: 100%;color: #000;text-shadow:#fff 1px 0 0, #fff 1px 0 0, #fff 1px 0 0;}
.movie-nav ul li h5{font-size:.55rem; margin: 0; padding: 0; line-height: 1rem;}

.movie-nav ul li:nth-child(1) span{background: url(../../assets/img/icon-h3-3.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(2) span{background: url(../../assets/img/icon-h3-2.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(3) span{background: url(../../assets/img/icon-h3-1.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(4) span{background: url(../../assets/img/icon-h3-10.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(5) span{background: url(../../assets/img/icon-h3-4.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(6) span{background: url(../../assets/img/icon-h3-5.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(7) span{background: url(../../assets/img/icon-h3-9.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(8) span{background: url(../../assets/img/icon-h3-6.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(9) span{background: url(../../assets/img/icon-h3-8.png) center center no-repeat; background-size: 100%;}
.movie-nav ul li:nth-child(10) span{background: url(../../assets/img/icon-h3-7.png) center center no-repeat; background-size: 100%;}

.movie-bn{ border-radius: 10px; margin-bottom: 0px; overflow: hidden; padding: 0;}
.movie-bn img{ width: 100%;border-radius: 10px;  }
.movie-box{  border-radius: 10px; background: #fff; margin-bottom: 10px; }
.movie-box-flex{display: flex;flex-wrap: wrap;}
.movie-box h3{padding: 0.2rem 0 0.3rem 0;height: 1rem; line-height: 1rem; border-bottom: 1px solid #EEE;}
.movie-box h3 span{padding-left: 35px; font-size: .6rem; color: #662281;font-weight: 500;
  background: url(../../assets/img/icon-h3-2.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-1{background: url(../../assets/img/icon-h3-3.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-2{background: url(../../assets/img/icon-h3-2.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-3{background: url(../../assets/img/icon-h3-1.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-4{background: url(../../assets/img/icon-h3-10.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-5{background: url(../../assets/img/icon-h3-4.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-6{background: url(../../assets/img/icon-h3-5.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-7{background: url(../../assets/img/icon-h3-9.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-8{background: url(../../assets/img/icon-h3-6.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-9{background: url(../../assets/img/icon-h3-8.png) 8px center no-repeat; background-size: 18px;}
.movie-box h3 span.icon-h3-10{background: url(../../assets/img/icon-h3-7.png) 8px center no-repeat; background-size: 18px;}

.movie-box h3 i{ float: right; font-size: .5rem; margin-right: 15px; color: #662281;  margin-top: 3px;}
.movie-box .item{ background: #fff; padding: 0 0 0 0; margin: 0.2rem 2%; width: 46%;box-sizing: content-box; border-radius: 5px;}
.movie-box .item a {
  background: #1a1a1a url(../../assets/img/loading_ho2.jpg) center center no-repeat; background-size:40px;
  position: relative;
  display: block;
  /* padding-top: 68%; */
  height: 6rem;
  border-radius: 4px;
  overflow: hidden;}
.movie-box .item a img{ width: 100%; height: 100%; vertical-align: middle; }
.movie-box .item h5{
  color: #333;
  font-size: .5rem;
  height: 1.3rem;
  line-height: .72rem;
  overflow: hidden;
  padding:.2rem;}
.nav-on{ height: 1rem; line-height: 1rem; font-size: .5rem; text-align: center; color: #fb4447;
  width: 5rem; margin: 0 auto 0 auto; border-radius: 5px; border: 1px solid #fb4447; margin-bottom: 5px;}
.search-word{ margin-bottom: 8px !important;}
.loadingBox{ position: fixed; top: calc(50% - 40px); left: calc(50% - 40px); width: 80px; height: 80px; line-height: 140px; overflow: hidden;
  background: #000 url(../../assets/img/loading.gif) center -20px no-repeat; background-size:110px ; color: #ccc; text-align: center; font-size: 12px; border-radius: 10px;}
</style>



// WEBPACK FOOTER //
// src/pages/layer1/vod.vue